/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
// import Modal from "react-responsive-modal";

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import Barcode from "react-barcode";
//import PerfectScrollbar from 'react-perfect-scrollbar';

// import Slider from "react-slick";

class CardReg extends PureComponent {
  state = {
    cardNumber1: '',
    cardNumber2: '',
    cardNumber3: '',
    cardNumber4: '',
    cardName: '',
    check: false,
    useAgree: false,
  };
  _onCardRegHide = () => {
    const { setCardRegShow } = this.props;
    this.setState({
      cardNumber1: '',
      cardNumber2: '',
      cardNumber3: '',
      cardNumber4: '',
      cardName: '',
    });
    setCardRegShow(false);
  };
  _onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value.replace(/[^0-9]/g, ''),
    });

    if (e.target.name === 'cardNumber1') {
      if (e.target.value.length === 4) {
        this.cardNumber2.focus();
      }
    }
    if (e.target.name === 'cardNumber2') {
      if (e.target.value.length === 4) {
        this.cardNumber3.focus();
      }
    }
    if (e.target.name === 'cardNumber3') {
      if (e.target.value.length === 4) {
        this.cardNumber4.focus();
      }
    }
  };
  _onCardCheck = async () => {
    // const { apiUrl, loginId } = this.props;
    const { cardNumber1, cardNumber2, cardNumber3, cardNumber4, useAgree } =
      this.state;

    if (useAgree === false) {
      toast.warn('이용약관에 동의해 주세요.');
      return false;
    }

    if (
      cardNumber1.toString().length < 4 ||
      cardNumber1.toString().length >= 5
    ) {
      toast.warn('카드번호가 정확하지 않습니다.');
      return false;
    }
    if (
      cardNumber2.toString().length < 4 ||
      cardNumber2.toString().length >= 5
    ) {
      toast.warn('카드번호가 정확하지 않습니다.');
      return false;
    }
    if (
      cardNumber3.toString().length < 4 ||
      cardNumber3.toString().length >= 5
    ) {
      toast.warn('카드번호가 정확하지 않습니다.');
      return false;
    }
    if (
      cardNumber4.toString().length < 3 ||
      cardNumber4.toString().length >= 4
    ) {
      toast.warn('카드번호가 정확하지 않습니다.');
      return false;
    }

    const cardNumber =
      cardNumber1.toString() +
      cardNumber2.toString() +
      cardNumber3.toString() +
      cardNumber4.toString();

    const result = await this._onCardCheckApi(cardNumber);
    const intReturn = result.data[0].intReturn;
    const cardInfo = result.data[0].listData;

    if (intReturn === 0) {
      this.setState({
        check: true,
        cardNumber: cardInfo[0].cardNumber,
        cardType: cardInfo[0].cardType,
      });
      toast.error(
        '등록이 가능한 카드입니다. 등록하기 버튼을 클릭하면 최종 등록됩니다.'
      );
    } else {
      toast.error('카드번호가 올바르지 않거나, 이미 등록된 카드입니다.');
    }
  };
  _onCardCheckApi = (cardNumber) => {
    const { apiUrl } = this.props;
    // const { cardName } = this.state;

    return axios
      .post(apiUrl + '/cardCheck', {
        params: {
          cardNumber: cardNumber,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _onReg = async () => {
    // const { apiUrl, loginId, setCardRegShow } = this.props;
    const { check, cardNumber } = this.state;

    if (
      check === false ||
      check === null ||
      check === undefined ||
      check === ''
    ) {
      toast.warn('이용가능 여부를 먼저 확인해주세요.');
      return false;
    }

    if (cardNumber === '' || cardNumber === null || cardNumber === undefined) {
      toast.warn('카드번호가 누락되었습니다.');
      return false;
    } else {
      const result = await this._onRegApi(cardNumber);
      if (result) {
        const intReturn = result.data[0].intReturn;
        const resultData = result.data[0].listData;
        if (intReturn === 0) {
          this.setState({
            resultData,
          });
          toast.success(
            '정상적으로 카드가 등록되었습니다. 카드의 잔액은 포인트로 통합되었습니다. 포인트는 온/오프라인에서 사용이 가능합니다.'
          );
          //카드 등록된 화면 전환.

          //setCardRegShow(false)
          //this._getCardList()
        } else if (intReturn === -100) {
          toast.error('회원정보가 잘못되었거나, 이미 탈퇴한 회원입니다.');
        } else if (intReturn === -2) {
          toast.error(
            '카드번호가 일치하지 않거나. 이미 사용중인 카드번호 입니다.'
          );
        } else if (intReturn === -1) {
          toast.error('이미 사용중인 카드번호 입니다.');
        } else if (intReturn === -3) {
          toast.error(
            '카드 등록 개수가 초과 되었습니다(계정당 5개까지 등록이 가능합니다.'
          );
        }
      }
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  _onRegApi = async (cardNumber) => {
    const { apiUrl, loginId, history } = this.props;
    const { cardName } = this.state;
    let cName = '';
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    if (cardName === '' || cardName === undefined || cardName === null) {
      cName = '';
    } else {
      cName = cardName;
    }
    return axios
      .post(
        apiUrl + '/cardReg',
        {
          params: {
            cardNumber: cardNumber,
            cardName: cName,
            userid: loginId,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');

    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._onReg();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _changeAgree = () => {
    const { useAgree } = this.state;
    this.setState({
      useAgree: !useAgree,
    });
  };
  _onChangeName = (e) => {
    this.setState({
      cardName: e.target.value,
    });
  };
  _onYak = () => {
    const { history } = this.props;
    this._onCardRegHide();
    history.push('/customer/4');
  };
  render() {
    const {
      cardNumber1,
      cardNumber2,
      cardNumber3,
      cardNumber4,
      cardName,
      check,
      useAgree,
    } = this.state;
    return (
      <Fragment>
        <div className="cashcard_con" style={{ background: 'none' }}>
          <div className="cashcard_pop_card">
            <ul className="radius2">
              <li>
                <input
                  maxLength={30}
                  name="cardName"
                  value={cardName}
                  onChange={this._onChangeName}
                  type="text"
                  className="common_input card_input on"
                  placeholder="카드명 (미입력 시 자동으로 부여됩니다.)"
                />
              </li>
              <li style={{ overflow: 'hidden' }}>
                <input
                  maxLength={4}
                  name="cardNumber1"
                  value={cardNumber1}
                  onChange={this._onChange}
                  type="text"
                  className="common_input card_input2 on"
                />
                <input
                  maxLength={4}
                  name="cardNumber2"
                  value={cardNumber2}
                  onChange={this._onChange}
                  type="text"
                  className="common_input card_input2 on"
                  ref={(ref) => (this.cardNumber2 = ref)}
                />
                <input
                  maxLength={4}
                  name="cardNumber3"
                  value={cardNumber3}
                  onChange={this._onChange}
                  type="text"
                  className="common_input card_input2 on"
                  ref={(ref) => (this.cardNumber3 = ref)}
                />
                <input
                  maxLength={3}
                  name="cardNumber4"
                  value={cardNumber4}
                  onChange={this._onChange}
                  type="text"
                  className="common_input card_input2 on"
                  ref={(ref) => (this.cardNumber4 = ref)}
                />
              </li>
            </ul>

            <ul className="radius1">
              <li>
                <div className="chek_group1">
                  <input
                    name="선택"
                    id="checkbox_1"
                    type="checkbox"
                    value=""
                    checked={useAgree}
                    className="checkbox_img"
                    onChange={this._changeAgree}
                  />
                  <label htmlFor="checkbox_1">전체 약관 동의</label>
                </div>
              </li>
              <li className="height_auto">
                <div className="chek_group2">
                  <input
                    name="선택"
                    id="checkbox_2"
                    type="checkbox"
                    value=""
                    checked={check}
                    className="checkbox_img"
                  />
                  <label htmlFor="checkbox_2">회원가입 약관 동의</label>
                  <a href="#">약관보기</a>
                </div>
                <div className="chek_group2">
                  <input
                    name="선택"
                    id="checkbox_3"
                    type="checkbox"
                    value=""
                    className="checkbox_img"
                  />
                  <label htmlFor="checkbox_3">
                    서비스 제공을 위한 개인정보 수집/이용
                  </label>
                  <a href="#">약관보기</a>
                </div>
              </li>
            </ul>
          </div>
          {check ? (
            <a
              style={{ cursor: 'pointer' }}
              onClick={this._onReg}
              className="btn_a"
            >
              포인트카드 등록하기
            </a>
          ) : (
            <a
              style={{ cursor: 'pointer' }}
              onClick={this._onCardCheck}
              className="btn_a"
            >
              카드 등록 여부 확인
            </a>
          )}
          {/*<a style={{cursor: 'pointer'}} onClick={this._onCardRegHide} className="btn_a" >취소</a>
                    <a href="#" className="btn_a">포인트카드 등록하기</a>*/}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(CardReg)));
